var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoutOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.714 20.036c0 .534-.43.964-.964.964H5.857A3.857 3.857 0 012 17.143V6.857A3.857 3.857 0 015.857 3H8.75a.963.963 0 110 1.929H5.857c-1.06 0-1.928.867-1.928 1.928v10.286c0 1.06.867 1.928 1.928 1.928H8.75c.534 0 .964.43.964.965zM22.31 11.34l-5.106-5.464A.963.963 0 1015.8 7.198l3.573 3.838H9.357c-.499 0-.928.434-.928.964s.431.964.928.964h9.98l-3.613 3.84a.963.963 0 00.042 1.362c.224.174.461.263.662.263a.96.96 0 00.702-.304l5.107-5.464a.899.899 0 00.073-1.32z",
    fill: "#777"
  })));
}

export default SvgLogoutOutline;